import React, { useState, useEffect } from "react";
import { Table, Popconfirm, Space, Dropdown, Modal, Form } from "antd";
import { Select, DatePicker, Button, Tooltip, Segmented, Tag, InputNumber, Empty, Typography } from "antd";
import moment from "moment";
import { TrainingAPI } from "../../api/TrainingAPI";
import "../../Styles/styles-InjuryTable.css";
import { formattedPlayerName } from "../../Utils/name_utils";
import { useSelector, useDispatch } from "react-redux";
import { ReloadOutlined } from "@ant-design/icons";
import { audioMessage as message } from "../Common/Notifications/audioMessage";
import { 
  PermissionedButton, 
  PermissionedSelect, 
  PermissionedDatePicker, 
  PermissionedInputNumber, 
  PermissionedSegmented, 
  PermissionedPopConfirm 
} from "../PermissionedComponents";
import { usePermissionCheck } from "../PermissionedComponents/usePermissionCheck";
import PermissionViewable from "../PermissionedComponents/PermissionViewable";

const { Option } = Select;

const INJURY_STATUS = {
  INJURED: "Injured",
  RTP: "Return to play",
  RECOVERED: "Recovered"
}

const InjuryInputForm = (props) => {

  const [name, setName] = useState(undefined);
  const [injuryLocation, setInjuryLocation] = useState(undefined);
  const [injuryType, setInjuryType] = useState(undefined);
  const [softTissue, setSoftTissue] = useState('N/A');
  const [surgery, setSurgery] = useState('N/A');
  const [referral, setReferral] = useState('N/A');
  const [image, setImage] = useState('N/A');
  const [seasonEnding, setSeasonEnding] = useState('N/A');
  const [activity, setActivity] = useState(undefined);
  const [drill, setDrill] = useState(undefined);
  const [selectedDate, setSelectedDate] = useState(undefined);
  const [drillList, setDrillList] = useState([]);

  const trainingAPI = new TrainingAPI();


  useEffect(() => {
    trainingAPI.getDrills().then((data) => setDrillList(data)).catch((error) => console.log(error));
  }, [])

  const {
    misc: {
      injury_types: injury_type_list, 
      injury_location_tree,
      injury_activity_list,
      user_permissions: userPermissions
    },
    players,
    info: { display_name: teamName}
  } = useSelector(({ team }) => team);

  const modifiedInjuryLocationTree = injury_location_tree.map(
    (item) => ({...item, onTitleClick: () => setInjuryLocation(item.key)}));

  const modified_drill_list = drillList.concat([
    {name: "Non Sport Related"},
    {name: "Pre Practice"},
    {name: "Post Practice"},
    {name: "Other"},
    {name: "N/A"},
  ])

  const onSubmit = () => {
    const payload = {
      name: name,
      injury_location: injuryLocation,
      injury_type: injuryType,
      soft_tissue: softTissue,
      surgery: surgery,
      referral: referral,
      image: image,
      season_ending: seasonEnding,
      activity: activity,
      drill: drill,
      injury_start_date: selectedDate
    }

    trainingAPI.newInjuryV2(payload).then((data) => {
      message.success(`${name} injury uploaded successfully.`);
    }).catch((error) => {
      if (error?.response?.status === 400 && error?.response?.data) {
        message.error(error.response.data);
        return
      } else {
        message.error("Error uploading injury");
      }
    })
    props?.setIsFormOpen(false);
  }

  return (
  <>

        <Form
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 20 }}
        layout="horizontal"
        style={{ maxWidth: 600 }}
      >

        <Form.Item 
          name="Date" 
          label="Date" 
          rules={[{ required: true }]} 
          validateDebounce={500}
          >
          <PermissionedDatePicker
            permissionCheck="AddPlayerInjuries"
            onChange={(date, dateString) => setSelectedDate(dateString)}
            format={"YYYY-MM-DD"}
            value={selectedDate}
          />
        </Form.Item>

        <Form.Item 
         name="Name" 
         label="Name" 
         rules={[{ required: true }]} 
         validateDebounce={500}
          >
        <PermissionedSelect
            permissionCheck="AddPlayerInjuries"
            showSearch
            allowClear
            style={{ width: 250 }}
            placeholder="Choose Player"
            value={name}
            onChange={(value) => setName(value)}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {players !== null ? (
              players.map((player, i) => {
                return (
                  <Option
                    key={i}
                    value={`${player.first_name} ${player.last_name}`}
                  >
                    {`${formattedPlayerName(
                      teamName,
                      `${player.first_name} ${player.last_name}`
                    )} #${player.number}`}
                  </Option>
                );
              })
            ) : (
              <></>
            )}
          </PermissionedSelect>
        </Form.Item>

        <Form.Item 
          name="Injury Type" 
          label="Injury Type" 
          rules={[{ required: true }]} 
          validateDebounce={500}
          >
        <PermissionedSelect
            permissionCheck="AddPlayerInjuries"
            showSearch
            allowClear={true}
            placeholder="Choose Injury Type"
            value={injuryType}
            style={{ width: 250 }}
            onChange={(value) => setInjuryType(value)}
            options={injury_type_list.map(x => ({'value': x, 'label': x}))}
          />
        </Form.Item>

        <Form.Item label="Soft Tissue">
        <PermissionedSegmented
          permissionCheck="AddPlayerInjuries"
          options={['Yes', 'No', 'N/A']}
          value={softTissue}
          onChange={(value) => setSoftTissue(value)}
        />
        </Form.Item>

        <Form.Item label="Injury Location" rules={[{ required: true }]} validateDebounce={500}>
        <Dropdown
					menu={{
						items: modifiedInjuryLocationTree,
						onClick: ({ key }) => {setInjuryLocation(key);},
					}}
          style={{ 
            width: 250,
            
           }}
           overlayStyle={{
            // maxHeight: '300px',
            // overflow: 'hidden', 
          }}
					trigger={["hover"]}
				>
          <Button
          style={{
            height: "auto",
            whiteSpace: "wrap",
            width: 250
          }}
          variant="outlined"
        >
            {injuryLocation ? injuryLocation : "Choose Injury Location"}
          </Button>
        </Dropdown>

        </Form.Item>

        <Form.Item label="Surgery">
          <PermissionedSegmented
            permissionCheck="AddPlayerInjuries"
            options={['Yes', 'No', 'N/A']}
            value={surgery}
            onChange={(value) => setSurgery(value)}
          />
        </Form.Item>

        <Form.Item label="Referral">
          <PermissionedSegmented
            permissionCheck="AddPlayerInjuries"
            options={['Yes', 'No', 'N/A']}
            value={referral}
            onChange={(value) => setReferral(value)}
          />
        </Form.Item>
          
        <Form.Item label="Image">
          <PermissionedSegmented
            permissionCheck="AddPlayerInjuries"
            options={['Yes', 'No', 'N/A']}
            value={image}
            onChange={(value) => setImage(value)}
          />
        </Form.Item>

        <Form.Item label="Season Ending">
          <PermissionedSegmented
            permissionCheck="AddPlayerInjuries"
            options={['Yes', 'No', 'N/A']}
            value={seasonEnding}
            onChange={(value) => setSeasonEnding(value)}
          />
        </Form.Item>

        <Form.Item label="Activity">
          <PermissionedSelect
            permissionCheck="AddPlayerInjuries"
            allowClear={true}
            showSearch
            placeholder="Choose Activity"
            value={activity}
            style={{ width: 250 }}
            onChange={(value) => setActivity(value)}
            options={injury_activity_list.map(x => ({'value': x, 'label': x}))}
          />
        </Form.Item>

        <Form.Item label="Drill">
          <PermissionedSelect
            permissionCheck="AddPlayerInjuries"
            allowClear={true}
            showSearch
            placeholder="Drill"
            value={drill}
            style={{ width: 250 }}
            onChange={(value) => setDrill(value)}
            options={modified_drill_list.map(x => ({'value': x.name, 'label': x.name}))}
          />
        </Form.Item>
        <Form.Item label={null}>
          <PermissionedButton 
            type="primary" 
            permissionCheck="AddPlayerInjuries"
            onClick={onSubmit}
          >
            Report Injury
          </PermissionedButton>
        </Form.Item>
      </Form>
  </>
  )

}

export const InjuryTable = (props) => {
  const [tableData, setTableData] = useState([]);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [showColumns, setShowColumns] = useState(["Name", "Injury Type", "Injury Location", "Injury Start Date", "Recovery Start Date", "Injury End Date", "Duration (Days)", "Status"]);

  // Filter states
  const [dateRange, setDateRange] = useState([null, null]);
  const [filters, setFilters] = useState({
    player: null,
    positions: [],
    groups: []
  });

  const trainingAPI = new TrainingAPI();
  const dateFormat = "YYYY-MM-DD";

  // Use permission check hook
  const { permissionDisabled } = usePermissionCheck("ViewPlayerInjuries");

  // Get data from Redux
  const {
    misc: {
      injury_types: injury_type_list, 
      injury_location_tree,
      injury_activity_list,
      user_permissions: userPermissions
    },
    players,
    positions,
    playerGroups,
    info: { display_name: teamName}
  } = useSelector(({ team }) => team);

  useEffect(() => {
    getInjuries();
  }, [isFormOpen]);

  const getInjuries = (filterParams = {}) => {
    // Prepare filter parameters for API request
    const apiFilters = {
      ...filterParams,
      start_date: dateRange[0],
      end_date: dateRange[1]
    };

    // Remove null/empty values
    Object.keys(apiFilters).forEach(key => {
      if (!apiFilters[key] || (Array.isArray(apiFilters[key]) && apiFilters[key].length === 0)) {
        delete apiFilters[key];
      }
    });
    trainingAPI.getInjuries(apiFilters)
      .then((data) => {
        const tableDataWithStatus = data.map( (injury) => ({...injury, status: getInjuryStatus(injury?.recovery_start_date, injury?.injury_end_date)}))
        return setTableData(tableDataWithStatus)
    });
  }

  const handleApplyFilters = () => {
    const filterParams = {
      player: filters.player,
      positions: filters.positions,
      groups: filters.groups
    };
    
    getInjuries(filterParams);
    message.success("Filters applied");
  };

  const handleClearFilters = () => {
    setDateRange([null, null]);
    setFilters({
      player: null,
      positions: [],
      groups: []
    });
    
    const clearedFilters = {
      player: null,
      positions: [],
      groups: []
    };
    const apiFilters = {
      ...clearedFilters,
      start_date: null,
      end_date: null
    };
    Object.keys(apiFilters).forEach(key => {
      if (!apiFilters[key] || (Array.isArray(apiFilters[key]) && apiFilters[key].length === 0)) {
        delete apiFilters[key];
      }
    });
    
    trainingAPI.getInjuries(apiFilters)
      .then((data) => {
        const tableDataWithStatus = data.map( (injury) => ({...injury, status: getInjuryStatus(injury?.recovery_start_date, injury?.injury_end_date)}))
        return setTableData(tableDataWithStatus)
    });
    message.success("Filters cleared");
  };

  const saveTable = () => {
    trainingAPI.updateInjury(tableData).then((data) => {
      message.success("Injury Info Updated");
      getInjuries()
    });
  };

  const onRecoveryDateChange = (value, e, dateString) => {
    const newTableData = tableData.map((data) => {
      if (value === data["injury_id"]) {
        if (moment(data["injury_start_date"]) > moment(dateString)) {
          message.error(
            "Recovery Start Date must be on or after Injury Start Date"
          );
          return data;
        }
        return {
          ...data,
          recovery_start_date: dateString,
          save_recover: false,
        };
      } else {
        return data;
      }
    });
    setTableData([...newTableData]);
  };

  const onInjuryEndDateChange = (value, e, dateString) => {
    const newTableData = tableData.map((data) => {
      if (value === data["injury_id"]) {
        if (moment(data["recovery_start_date"]) > moment(dateString)) {
          message.error(
            "Injury End Date must be on or after Recovery Start Date"
          );
          return data;
        }
        data["injury_end_date"] = dateString;
        data["save_end"] = false;
        return { ...data };
      } else {
        return data;
      }
    });
    setTableData([...newTableData]);
  };

  const handleGameCountChange = (injury_id, value) => {
    const newTableData = tableData.map((data) => {
      if (injury_id == data["injury_id"]) {
        data["games_lost"] = value;
        return { ...data };
      } else {
        return data;
      }
    });
    setTableData([...newTableData]);
  }
  const handleDelete = async () => {

    const del_all = selectedRowKeys.map((injuryId) => {
      trainingAPI.deleteInjury(injuryId).then(() => {}).catch((data) => {console.log(data);})
    })

    const fin = await Promise.all(del_all);
    message.success("Injury data deleted successfully.");
    getInjuries();
  };

  const getInjuryStatus = (recoveryStartDate, injuryEndDate) => {
    if(injuryEndDate) {
      return INJURY_STATUS.RECOVERED
    }

    if(recoveryStartDate) {
      return INJURY_STATUS.RTP
    }

    return INJURY_STATUS.INJURED
  }

  const generateFilters = (data, key) => {
    return [
      ...new Set(data.map((item) => item[key])),
    ].map((value) => ({ text: value, value }));
  };

  const handleColumnChange = (column) => {
    if (showColumns.includes(column)) {
      setShowColumns(showColumns.filter((col) => col !== column));
    } else {
      setShowColumns([...showColumns, column]);
   }
  }

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      fixed: 'left',
      sorter: {
        compare: ((a, b) => {
          const a_fullname = `${a["player_id__first_name"]} ${a["player_id__last_name"]}`;
          const b_fullname = `${b["player_id__first_name"]} ${b["player_id__last_name"]}`;
          return a_fullname.localeCompare(b_fullname);
        }),
        multiple: 1,
      },
      render: (_, data) => (
        <span>
          {formattedPlayerName(
            props.team_name,
            `${data["player_id__first_name"]} ${data["player_id__last_name"]}`
          )}
        </span>
      ),
    },
    {
      title: "Position",
      dataIndex: "player_id__position",
      key: "player_id__position",
      sorter: {
        compare: (a, b) => a.player_id__position.localeCompare(b.player_id__position),
        multiple: 1,
      },
      render: (data) => <span>{data}</span>,
      filters: generateFilters(tableData, "player_id__position"),
      onFilter: (value, record) => record["player_id__position"] === value,
    },
    {
      title: "Injury Type",
      dataIndex: "injury_type",
      key: "injury_type",
      sorter: {
        compare: (a, b) => a.injury_type.localeCompare(b.injury_type),
        multiple: 2,
      },
      render: (injuryType) => <span>{injuryType}</span>,
      filters: generateFilters(tableData, "injury_type"),
      onFilter: (value, record) => record["injury_type"] === value,
    },
    {
      title: "Soft Tissue",
      dataIndex: "is_soft_tissue",
      key: "is_soft_tissue",
      sorter: {
        compare: (a, b) => a.is_soft_tissue.localeCompare(b.is_soft_tissue),
        multiple: 2,
      },
      render: (is_soft_tissue) => <span>{is_soft_tissue}</span>,
      filters: generateFilters(tableData, "is_soft_tissue"),
      onFilter: (value, record) => record["is_soft_tissue"] === value,
    },
    {
      title: "Injury Location",
      dataIndex: "injury_location",
      key: "injury_location",
      sorter: {
        compare: (a, b) => a.injury_location.localeCompare(b.injury_location),
        multiple: 2,
      },
      render: (injuryLocation) => <span>{injuryLocation}</span>,
      filters: generateFilters(tableData, "injury_location"),
      onFilter: (value, record) => record["injury_location"] === value,
    },
    {
      title: "Surgery",
      dataIndex: "is_surgery",
      key: "is_surgery",
      sorter: {
        compare: (a, b) => a.is_surgery.localeCompare(b.is_surgery),
        multiple: 2,
      },
      render: (is_surgery) => <span>{is_surgery}</span>,
      filters: generateFilters(tableData, "is_surgery"),
      onFilter: (value, record) => record["is_surgery"] === value,
    },

    {
      title: "Referral",
      dataIndex: "is_referral",
      key: "is_referral",
      sorter: {
        compare: (a, b) => a.is_referral.localeCompare(b.is_referral),
        multiple: 2,
      },
      render: (is_referral) => <span>{is_referral}</span>,
      filters: generateFilters(tableData, "is_referral"),
      onFilter: (value, record) => record["is_referral"] === value,
    },

    {
      title: "Image",
      dataIndex: "is_image",
      key: "is_image",
      sorter: {
        compare: (a, b) => a.is_image.localeCompare(b.is_image),
        multiple: 2,
      },
      render: (is_image) => <span>{is_image}</span>,
      filters: generateFilters(tableData, "is_image"),
      onFilter: (value, record) => record["is_image"] === value,
    },

    {
      title: "Season Ending",
      dataIndex: "is_season_ending",
      key: "is_season_ending",
      sorter: {
        compare: (a, b) => a.is_season_ending.localeCompare(b.is_season_ending),
        multiple: 2,
      },
      render: (is_season_ending) => <span>{is_season_ending}</span>,
      filters: generateFilters(tableData, "is_season_ending"),
      onFilter: (value, record) => record["is_season_ending"] === value,
    },

    {
      title: "Activity",
      dataIndex: "activity",
      key: "activity",
      sorter: {
        compare: (a, b) => a.activity.localeCompare(b.activity),
        multiple: 2,
      },
      render: (activity) => <span>{activity}</span>,
      filters: generateFilters(tableData, "activity"),
      onFilter: (value, record) => record["activity"] === value,
    },

    {
      title: "Drill",
      dataIndex: "drill",
      key: "drill",
      sorter: {
        compare: (a, b) => a.drill.localeCompare(b.drill),
        multiple: 2,
      },
      render: (drill) => <span>{drill}</span>,
      filters: generateFilters(tableData, "drill"),
      onFilter: (value, record) => record["drill"] === value,
    },
    {
      title: "Injury Start Date",
      dataIndex: "injury_start_date",
      key: "injury_start_date",
      sorter: {
        compare: (a, b) => a.injury_start_date.localeCompare(b.injury_start_date),
        multiple: 3,
      },
      render: (injuryStartDate) => <span>{injuryStartDate}</span>,
      filters: generateFilters(tableData, "injury_start_date"),
      onFilter: (value, record) => record["injury_start_date"] === value,
    },
    {
      title: "Recovery Start Date",
      dataIndex: "recovery_start_date",
      key: "recovery_start_date",
      sorter: {
        compare: (a, b) => a.recovery_start_date.localeCompare(b.recovery_start_date),
        multiple: 4,
      },
      filters: generateFilters(tableData, "recovery_start_date"),
      onFilter: (value, record) => record["recovery_start_date"] === value,
      render: (recoveryStartDate, data) => {
        if (recoveryStartDate !== null && data["save_recover"] === undefined) {
          return <span>{recoveryStartDate}</span>;
        } else {
          return (
            <PermissionedDatePicker
              permissionCheck="EditPlayerInjuries"
              key={data["injury_id"]}
              placeholder="Select Date"
              onChange={(e, other) =>
                onRecoveryDateChange(data["injury_id"], e, other)
              }
              value={
                recoveryStartDate !== null
                  ? moment(recoveryStartDate, dateFormat)
                  : null
              }
            />
          );
        }
      },
    },
    {
      title: "Injury End Date",
      dataIndex: "injury_end_date",
      key: "injury_end_date",
      sorter: {
        compare: (a, b) => a.injury_end_date.localeCompare(b.injury_end_date),
        multiple: 4,
      },
      filters: generateFilters(tableData, "injury_end_date"),
      onFilter: (value, record) => record["injury_end_date"] === value,
      render: (injuryEndDate, data) => {
        if (injuryEndDate !== null && data["save_end"] === undefined) {
          return <span>{injuryEndDate}</span>;
        } else {
          return (
            <PermissionedDatePicker
              permissionCheck="EditPlayerInjuries"
              key={data["injury_id"]}
              placeholder="Select Date"
              onChange={(e, other) =>
                onInjuryEndDateChange(data["injury_id"], e, other)
              }
              value={
                injuryEndDate !== null
                  ? moment(injuryEndDate, dateFormat)
                  : null
              }
            />
          );
        }
      },
    },

    {
      title: "Duration (Days)",
      dataIndex: "duration",
      key: "duration",
      sorter: {
        compare: (a, b) => {
          const a_duration = moment(a["injury_end_date"]).diff(moment(a["injury_start_date"]), 'days');
          const b_duration = moment(b["injury_end_date"]).diff(moment(b["injury_start_date"]), 'days');
          return a_duration - b_duration;
        },
        multiple: 2,
      },
      render: (_, data) => {
        if (data['injury_end_date']) {
          const end_date = data["injury_end_date"];
          const start_date = data["injury_start_date"];
          const duration = moment(end_date).diff(moment(start_date), 'days');
          return (<span>{duration}</span>)

        }
        return (<span>-</span>)
      }
    },

    {
      title: "Games Lost",
      dataIndex: "games_lost",
      key: "games_lost",
      sorter: {
        compare: (a, b) => a.games_lost - b.games_lost,
        multiple: 4,
      },
      filters: generateFilters(tableData, "games_lost"),
      onFilter: (value, record) => record["games_lost"] === value,
      render: (games_lost, data) => {
        if (data['injury_end_date'] !== null && data["save_end"] === undefined) {
          return <span>{games_lost}</span>;
        } else {
          return (
            <PermissionedInputNumber 
              permissionCheck="EditPlayerInjuries"
              min={0} 
              max={100000} 
              value={games_lost} 
              onChange={(val)=>handleGameCountChange(data['injury_id'], val)} 
            />
          );
        }
      },
    },

    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      sorter: {
        compare: (a, b) => a.status.localeCompare(b.status),
        multiple: 2,
      },
      render: (status) => <span>{status}</span>,
      onFilter: (value, record) => record["status"] === value,
      filters: ["Injured", "Return to play", "Recovered"].map((value) => ({ text: value, value: value })),

    }
  ];

  return (
    <div
      style={{
        margin: "24px 0px",
      }}
    >
      <div style={{ display: "flex", gap: 16 }}>

      <PermissionedButton 
        type="primary"
        permissionCheck="AddPlayerInjuries"
        onClick={() => setIsFormOpen(true)}
      >
        Report Injury
      </PermissionedButton>
      <Button 
        variant="outlined"
        onClick={() => {getInjuries(); message.success("Injuries refreshed")}}
        style={{right: 0, position: 'absolute'}}
        icon={<ReloadOutlined />}
        />
      </div>

      <Modal 
        title="New Injury" 
        open={isFormOpen}
        onClose={() => setIsFormOpen(false)}
        onCancel={() => setIsFormOpen(false)}
        destroyOnClose={true}
        footer={null}
        >
          <InjuryInputForm setIsFormOpen={setIsFormOpen}/>
        </Modal>

        <div className="filter-container" style={{
          display: "flex",
          flexWrap: "nowrap",
          gap: "8px",
          alignItems: "center",
          padding: "12px",
          backgroundColor: "#f5f5f5",
          borderRadius: "8px",
          marginTop: "16px",
          overflowX: "auto"
        }}>
          <Typography.Text style={{fontSize: '14px', fontWeight: 'bold', whiteSpace: 'nowrap'}}>Filters:</Typography.Text>

          <DatePicker.RangePicker
            style={{ borderRadius: "5px", width: 200 }}
            format={dateFormat}
            value={[
              dateRange[0] ? moment(dateRange[0], dateFormat) : null,
              dateRange[1] ? moment(dateRange[1], dateFormat) : null,
            ]}
            onChange={(dates, dateStrings) => setDateRange(dateStrings)}
            placeholder={['Start Date', 'End Date']}
          />
          
          <Select
            showSearch
            allowClear
            style={{ width: 140 }}
            placeholder="Choose Player"
            onChange={(value) => {setFilters({...filters, player: value})}}
            value={filters?.player || null}
            filterOption={(input, option) =>
                option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
                         {players?.map(
               (player, i) => ({
                   key: i,
                   value: player.player_id,
                   label: formattedPlayerName(teamName, `${player.first_name} ${player.last_name}`)
             }))
             .filter(item => item.label !== "Unknown")
             .map((player) => (
                 <Option key={player.key} value={player.value}>
                     {player.label}
                 </Option>
             ))}    
          </Select>

          <Select
            showSearch
            allowClear
            placeholder="All Positions"
            style={{ minWidth: 120, maxWidth: 250 }}
            options={positions.map((position) => ({
              label: position,
              value: position,
            }))}
            onChange={(value) => {setFilters({...filters, positions: value})}}   
            mode="multiple"
            maxTagCount={2}
            maxTagTextLength={8}
            filterOption={(input, option) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
            value={filters?.positions || []}
          />

          <Select
            showSearch
            allowClear
            placeholder="All Groups"
            style={{ minWidth: 120, maxWidth: 250 }}
            options={playerGroups.map((group) => ({
              label: group.name,
              value: group.player_group_id,
            }))}
            onChange={(value) => {setFilters({...filters, groups: value})}}   
            mode="multiple"
            maxTagCount={2}
            maxTagTextLength={10}
            filterOption={(input, option) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
            value={filters?.groups || []}
          />

          <div style={{ display: "flex", gap: "6px", flexShrink: 0 }}>
            <Button 
              type="primary" 
              onClick={handleApplyFilters}
              style={{ borderRadius: "5px" }}
              size="small"
            >
              Apply
            </Button>
            <Button 
              onClick={handleClearFilters}
              style={{ borderRadius: "5px" }}
              size="small"
            >
              Clear
            </Button>
          </div>
        </div>
      
        <div style={{
          fontSize: 12,
          marginTop: 16,
          backgroundColor: '#E5F3FD',
          padding: '5px',
          borderRadius: '5px',
        }}>
          <b>Show Columns: </b>
          <span style={{marginLeft: '5px'}}>
            {columns.map((column) => (
              <Tag.CheckableTag 
                style={{margin: '2px'}}
                key={column.title} 
                checked={showColumns.includes(column.title)} 
                onChange={() => handleColumnChange(column.title)}
              >
                {column.title}
              </Tag.CheckableTag>))
              }
              </span>
        </div>

        <Table
          className="custom-table-container"
          rowClassName={() => "custom-table-row"} // Add class to each row
          columns={columns.filter((column) => showColumns.includes(column.title))}
          scroll={{ x: 1200, y: 1000 }}        
          size="small"
          dataSource={tableData}
          bordered
          rowKey={(record) => record.injury_id}
          style={{ marginTop: 16 }}
          pagination={{
            defaultPageSize: 25,
            showSizeChanger: true,
            pageSizeOptions: ["10", "25", "50", "100"],
            position: ["bottomLeft"],
          }}
          locale={permissionDisabled ? {emptyText: <Empty description="You do not have permission to view the Injury Table." />}: null}
          loading={props.loading}
          rowSelection={{
            selectedRowKeys,
            onChange: setSelectedRowKeys,
            selections: [Table.SELECTION_ALL, Table.SELECTION_NONE],
          }}
        />
<div style={{marginTop: '10px'}}/>
        <PermissionedButton 
          type="primary" 
          permissionCheck="EditPlayerInjuries"
          onClick={saveTable}
          style={permissionDisabled ? {marginTop: '10px'}: null}
        >
          Save
        </PermissionedButton>

        <PermissionedPopConfirm
          permissionCheck="DeletePlayerInjuries"
          title="Are you sure you want to delete the selected injuries?"
          onConfirm={async () => {await handleDelete();getInjuries()}}
          okText="Yes"
          cancelText="No"
        >
          <PermissionedButton 
            type="primary" 
            permissionCheck="DeletePlayerInjuries"
            disabled={selectedRowKeys.length == 0}
            style={{ marginLeft: 8, marginTop: permissionDisabled? '10px': null }}
          >
            Delete Selected Injuries
          </PermissionedButton>
        </PermissionedPopConfirm>
    </div>
  );
};
